import React, { useState, useEffect } from 'react';
import './services/axiosConfig';
import Dashboard from './components/Dashboard.js';
import Pacientes from './components/Pacientes.js';
import Turnos from './components/Turnos.js';
import Pagos from './components/Pagos.js';
import Configuracion from './components/Configuracion.js';
import Login from './components/Login';
import BuscadorPacientes from './components/BuscadorPacientes';
import FiltradorTurnos from './components/FiltradorTurnos';
import RecuperacionPassword from './components/RecuperacionPassword';
import CalendarioTurnos from './components/CalendarioTurnos';
import HistorialClinico from './components/HistorialClinico';
import GestionUsuarios from './components/GestionUsuarios';
import Reportes from './components/Reportes';
import AgendarTurno from './components/AgendarTurno';
import ControlAsistencia from './components/ControlAsistencia';
import NotificationProvider from './context/NotificationContext';
import authService from './services/authService';
import { notificationSystem } from './utils/notifications';
import config from './config';
import './styles/responsive.css';
import './App.css';
import { AuthProvider } from './context/AuthContext';

// Componente de Login
function LoginComponent({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const login = async (e) => {
    e.preventDefault();
    setValidationErrors({});
    
    // Validar
    const errors = {};
    const emailError = validators.email(email);
    const passwordError = validators.password(password);
    
    if (emailError) errors.email = emailError;
    if (passwordError) errors.password = passwordError;
    
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setLoading(true);
    try {
      const data = await authService.login(email, password);
      localStorage.setItem(config.tokenKey, data.token);
      localStorage.setItem(config.userKey, JSON.stringify(data.user));
      
      onLogin(data);
      setError('');
      notificationSystem.success('Sesión iniciada correctamente');
    } catch (err) {
      const errorMsg = err.message || 'Credenciales inválidas';
      setError(errorMsg);
      notificationSystem.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={login} className="login-form">
        <h2>Consultorio Psicológico</h2>
        <h3>Iniciar Sesión</h3>
        {error && <div className="error">{error}</div>}
        
        <div className="form-group">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            className={validationErrors.email ? 'input-error' : ''}
          />
          {validationErrors.email && <span className="error-text">{validationErrors.email}</span>}
        </div>

        <div className="form-group">
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            className={validationErrors.password ? 'input-error' : ''}
          />
          {validationErrors.password && <span className="error-text">{validationErrors.password}</span>}
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Ingresando...' : 'Ingresar'}
        </button>
        
        <div className="demo-credentials">
          <p><strong>Credenciales de prueba:</strong></p>
          <p>Email: siomara@consultorio.com</p>
          <p>Contraseña: password123</p>
        </div>
      </form>
    </div>
  );
}

// Componente Principal
function App() {
  // Detectar si es una ruta pública (portal de paciente)
  const rutaActual = window.location.pathname;
  const esRutaPublica = rutaActual.startsWith('/agendar/');
  
  // Si es ruta pública, renderizar solo el componente público
  if (esRutaPublica) {
    const token = rutaActual.split('/agendar/')[1];
    return (
      <NotificationProvider>
        <AgendarTurno token={token} />
      </NotificationProvider>
    );
  }
  
  // Para rutas privadas, continuar con la lógica normal
  const [token, setToken] = useState(localStorage.getItem(config.tokenKey));
  const [user, setUser] = useState(null);
  const [paginaActual, setPaginaActual] = useState('dashboard');
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [mostrarRecuperacion, setMostrarRecuperacion] = useState(false);
  const [sidebarAbierto, setSidebarAbierto] = useState(false);

  const toggleSidebar = () => {
    setSidebarAbierto(!sidebarAbierto);
  };

  const cerrarSidebar = () => {
    setSidebarAbierto(false);
  };

  useEffect(() => {
    const storedToken = localStorage.getItem(config.tokenKey);
    const storedUser = localStorage.getItem(config.userKey);
    
    if (storedToken && storedUser) {
      try {
        setToken(storedToken);
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('❌ Error parsing stored user:', error);
        localStorage.removeItem(config.tokenKey);
        localStorage.removeItem(config.userKey);
      }
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (userData) => {
    console.log('🔐 Login en App - userData recibido:', userData);
    console.log('🔐 userData.token:', userData?.token ? 'Presente' : 'FALTA');
    console.log('🔐 userData.user:', userData?.user ? 'Presente' : 'FALTA');
    
    // Verificar que el token esté en localStorage
    const tokenEnStorage = localStorage.getItem(config.tokenKey);
    const userEnStorage = localStorage.getItem(config.userKey);
    console.log('✅ Token en localStorage:', tokenEnStorage ? 'SÍ' : '❌ NO');
    console.log('✅ User en localStorage:', userEnStorage ? 'SÍ' : '❌ NO');
    
    // Actualizar estado
    setToken(userData?.token);
    setUser(userData?.user);
    setPaginaActual('dashboard');
    
    console.log('✅ Estado React actualizado - redirigiendo a dashboard');
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    authService.logout();
    notificationSystem.success('Sesión cerrada correctamente');
  };

  const navegarA = (pagina, mostrarForm = false) => {
    setPaginaActual(pagina);
    setMostrarFormulario(mostrarForm);
    cerrarSidebar(); // Cerrar sidebar al navegar en móvil
  };

  const handleNavegacionDashboard = (accion) => {
    switch (accion) {
      case 'pacientes':
        navegarA('pacientes', true);
        break;
      case 'turnos':
        navegarA('turnos', true);
        break;
      case 'pagos':
        navegarA('pagos', true);
        break;
      default:
        navegarA(accion);
    }
  };

  if (isLoading) {
    return <div className="loading">Cargando...</div>;
  }

  // Si no hay token y no está recuperando contraseña, mostrar login o init
  if (!token || !user) {
    if (mostrarRecuperacion) {
      return (
        <NotificationProvider>
          <RecuperacionPassword onVolver={() => setMostrarRecuperacion(false)} />
        </NotificationProvider>
      );
    }
    return (
      <NotificationProvider>
        <Login 
          onLogin={handleLogin} 
          onRecuperarPassword={() => setMostrarRecuperacion(true)}
        />
      </NotificationProvider>
    );
  }

  const renderContenido = () => {
    switch (paginaActual) {
      case 'dashboard':
        return <Dashboard onNavegar={handleNavegacionDashboard} />;
      case 'pacientes':
        return (
          <Pacientes
            mostrarForm={mostrarFormulario}
            onCerrarForm={() => setMostrarFormulario(false)}
          />
        );
      case 'buscador-pacientes':
        return <BuscadorPacientes />;
      case 'turnos':
        return (
          <Turnos 
            mostrarForm={mostrarFormulario}
            onCerrarForm={() => setMostrarFormulario(false)}
          />
        );
      case 'filtrador-turnos':
        return <FiltradorTurnos />;
      case 'calendario':
        return <CalendarioTurnos />;
      case 'historial':
        return <HistorialClinico />;
      case 'reportes':
        return <Reportes />;
      case 'pagos':
        return (
          <Pagos 
            mostrarForm={mostrarFormulario}
            onCerrarForm={() => setMostrarFormulario(false)}
          />
        );
      case 'configuracion':
        return <Configuracion />;
      case 'usuarios':
        return <GestionUsuarios />;
      case 'asistencia':
        return <ControlAsistencia />;
      default:
        return <Dashboard onNavegar={handleNavegacionDashboard} />;
    }
  };

  return (
    <AuthProvider>
      <NotificationProvider>
        <div className="app">
          <header className="header">
            <button 
              className="toggle-sidebar-btn" 
              onClick={toggleSidebar}
              aria-label="Abrir menú"
            >
              ☰
            </button>
            <h1 className="logo">Consultorio Psicológico</h1>
            <div className="user-info">
              <span className="user-name">Bienvenido/a, {user?.nombre || user?.email}</span>
              {user?.rol && (
                <span className={`rol-badge rol-${user.rol}`}>
                  {user.rol === 'admin' ? '👑 Admin' : 
                   user.rol === 'secretaria' ? '📋 Secretaria' : 
                   '👨‍⚕️ Profesional'}
                </span>
              )}
              <button onClick={logout} className="logout-btn">Cerrar Sesión</button>
            </div>
          </header>
          
          {/* Overlay para cerrar sidebar en móvil */}
          {sidebarAbierto && (
            <div 
              className="sidebar-overlay" 
              onClick={cerrarSidebar}
            />
          )}
          
          <div className="main-content">
            <aside className={`sidebar ${sidebarAbierto ? 'open' : ''}`}>
              <nav>
                <button 
                  className={paginaActual === 'dashboard' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('dashboard')}
                >
                  📊 Dashboard
                </button>
                <button 
                  className={paginaActual === 'pacientes' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('pacientes')}
                >
                  👥 Pacientes
                </button>
                <button 
                  className={paginaActual === 'buscador-pacientes' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('buscador-pacientes')}
                >
                  🔍 Buscar Pacientes
                </button>
                <button 
                  className={paginaActual === 'turnos' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('turnos')}
                >
                  📅 Turnos
                </button>
                <button 
                  className={paginaActual === 'filtrador-turnos' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('filtrador-turnos')}
                >
                  🎯 Filtrar Turnos
                </button>
                <button 
                  className={paginaActual === 'calendario' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('calendario')}
                >
                  📅 Calendario
                </button>
                <button 
                  className={paginaActual === 'historial' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('historial')}
                >
                  📋 Historial Clínico
                </button>
                <button 
                  className={paginaActual === 'reportes' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('reportes')}
                >
                  📊 Reportes
                </button>
                <button 
                  className={paginaActual === 'asistencia' ? 'nav-btn active' : 'nav-btn'}
                  onClick={() => navegarA('asistencia')}
                >
                  ✓ Control de Asistencia
                </button>
                {(user?.rol === 'admin' || user?.rol === 'secretaria') && (
                  <button 
                    className={paginaActual === 'pagos' ? 'nav-btn active' : 'nav-btn'}
                    onClick={() => navegarA('pagos')}
                  >
                    💰 Pagos
                  </button>
                )}
                {user?.rol === 'admin' && (
                  <button 
                    className={paginaActual === 'configuracion' ? 'nav-btn active' : 'nav-btn'}
                    onClick={() => navegarA('configuracion')}
                  >
                    ⚙️ Configuración
                  </button>
                )}
                {user?.rol === 'admin' && (
                  <button 
                    className={paginaActual === 'usuarios' ? 'nav-btn active' : 'nav-btn'}
                    onClick={() => navegarA('usuarios')}
                  >
                    👥 Usuarios
                  </button>
                )}
              </nav>
            </aside>

            <main className="content">
              {renderContenido()}
            </main>
          </div>
        </div>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
